import * as cookie from 'app/libs/cookie';

export const setCookieMidnight = (key) => {
	const now = new Date(); // 현재 시간
	const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0); // 오늘 자정 (내일 00:00:00)
	const minutesUntilMidnight = Math.ceil((midnight - now) / (1000 * 60)); // 자정까지 남은 분

	cookie.setCookie(key, 'true', 0, 0, minutesUntilMidnight);
};

export default null;
